import { useState, useEffect, useCallback, useRef } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutter
const VERSION_URL = '/version.json';

interface VersionInfo {
  hash: string;
  buildTime: string;
}

export function useVersionCheck() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const initialHash = useRef<string | null>(null);

  const checkVersion = useCallback(async () => {
    try {
      // Cache-bust for å alltid hente siste versjon fra server
      const response = await fetch(`${VERSION_URL}?t=${Date.now()}`);
      if (!response.ok) return;

      const data: VersionInfo = await response.json();
      if (!data.hash || data.hash === 'dev') return;

      if (initialHash.current === null) {
        // Første sjekk — lagre nåværende hash
        initialHash.current = data.hash;
      } else if (data.hash !== initialHash.current) {
        setNewVersionAvailable(true);
      }
    } catch {
      // Ignorer nettverksfeil — prøver igjen ved neste poll
    }
  }, []);

  const refresh = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    checkVersion();

    const interval = setInterval(checkVersion, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [checkVersion]);

  return { newVersionAvailable, refresh };
}
